import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useDynamicConfigValue } from '@/hooks/use-dynamic-config-value';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

interface Props {
  containerStyle?: StyleProp<ViewStyle>;
  variantPackUUID: string;
}

export const ListItemDisplayText: React.FC<Props> = ({
  containerStyle,
  variantPackUUID,
}) => {
  const { getVariantPackInfo } = useVariantPackInfoContext();
  const displayConfig = useDynamicConfigValue('list_item_display_config');
  const [styles] = useStyles();
  const vpInfo = getVariantPackInfo(variantPackUUID);

  if (!vpInfo?.listItemDisplayText || !displayConfig?.enabled) {
    return null;
  }

  return (
    <View style={[styles.base, containerStyle]}>
      <Text style={[TYPOGRAPHY.small, styles.text]}>
        {vpInfo.listItemDisplayText}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    borderTopColor: theme.colors.divider,
    borderTopWidth: 1,
    paddingVertical: 4,
  },
  text: {
    lineHeight: 20,
  },
}));
